export const AssessmentVisibility = {
  PRIVATE: 1,
  PUBLIC: 2,
};

export const AssessmentVisibilityMap = {
  1: "Private",
  2: "Public",
};

export const AssessmentWorkflowStage = {
  DETAILS: 1,
  DURATION: 2,
  SECTIONS: 3,
  CONFIGURE_AND_PUBLISH: 4,
};

export const AssessmentWorkflowStageMap = {
  1: "Assessment Details",
  2: "Duration",
  3: "Add Questions",
  4: "Configure & Publish",
};

export const HOURS_TO_MILLISECONDS = 3600000;

export const AssessmentWorkflowStageSequence = [
  AssessmentWorkflowStage.DETAILS,
  AssessmentWorkflowStage.DURATION,
  AssessmentWorkflowStage.SECTIONS,
  AssessmentWorkflowStage.CONFIGURE_AND_PUBLISH,
];

export const ClosingTimeIntervals = [
  { label: "Never", value: 0 },
  { label: "15 minutes after start time", value: 15 },
  { label: "30 minutes after start time", value: 30 },
  { label: "45 minutes after start time", value: 45 },
  { label: "60 minutes after start time", value: 60 },
];

export const DurationType = {
  ASSESSMENT_BASED: 1,
  SECTION_OR_QUESTION_BASED: 2,
};

export const AssessmentDurationDefaultValue = 0;

// All values are in milliseconds
export const AssessmentDurationIntervals = [
  { label: "30 minutes", value: 1800000 },
  { label: "1 hour", value: 3600000 },
  { label: "1 hour 30 minutes", value: 5400000 },
  { label: "2 hour", value: 7200000 },
  { label: "2 hour 30 minutes", value: 9000000 },
  { label: "3 hour", value: 10800000 },
  { label: "3 hour 30 minutes", value: 12600000 },
  { label: "4 hour", value: 14400000 },
  { label: "4 hour 30 minutes", value: 16200000 },
  { label: "5 hour", value: 18000000 },
  { label: "5 hour 30 minutes", value: 19800000 },
  { label: "6 hour", value: 21600000 },
];

export const AssessmentAllowedAttempts = [
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
];

export const AssessmentState = {
  DRAFT: 1,
  PUBLISHED: 2,
  ARCHIVED: 3,
  DELETED: 4,
};

export const AssessmentStateMap = {
  1: "Draft",
  2: "Published",
  3: "Archived",
  4: "Deleted",
};

export const AssessmentWorkFlowTrigger = {
  HOME_CREATE_CTA: 1,
  HOME_COPY_CTA: 2,
  MANAGE_EDIT_CTA: 2,
  OPT_IN_EDIT_CTA: 3,
  OPT_IN_CRATE_CTA: 4,
};

export const QuestionType = {
  TEXT: 1,
  MCQ: 2,
  SCQ: 3,
  FILL_BLANKS: 4,
  CODE: 5,
  VIDEO: 6,
};

export const QuestionTypeMap = {
  1: "Paragraph",
  2: "MCQ",
  3: "SCQ",
  4: "Fill in blanks",
  5: "Code",
  6: "Video Question",
};

export const QuestionVisibility = {
  PRIVATE: 1,
  PUBLIC: 2,
};

export const EntityAttachedWithAssessment = {
  NONE: 1,
  SKYLIFT: 2,
};

export const ASSESSMENT_STATUS = {
  COMPLETED_ASSESSMENT: "Completed Assessment",
  ONGOING: "Ongoing",
  UNATTENDED: "Unattended",
};

export const ANSWER_STATUS = {
  UNATTEMPTED: 1,
  CORRECT: 2,
  INCORRECT: 3,
};

export const ANSWER_STATUS_MAP = {
  1: "Unevaluated",
  2: "Correct",
  3: "Incorrect",
};

export const USER_RESULT = {
  UNEVALUATED: 1,
  FAILED: 2,
  PASSED: 3,
};

export const USER_RESULT_MAP = {
  1: "Unevaluated",
  2: "Failed",
  3: "Passed",
};
